module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "is-clearfix"
  }, [_c('a', {
    staticClass: "is-pulled-right lxm-login-other-button__register",
    on: {
      "click": _vm.registerClicked
    }
  }, [_vm._v("注册")]), _vm._v(" "), (!_vm.needPhone) ? [_c('a', {
    staticClass: "is-pulled-right lxm-login-other-button__way",
    on: {
      "click": _vm.emailClicked
    }
  }, [_vm._v("邮箱登录")])] : _vm._e(), _vm._v(" "), (_vm.needPhone) ? [_c('a', {
    staticClass: "is-pulled-right lxm-login-other-button__way",
    on: {
      "click": _vm.phoneClicked
    }
  }, [_vm._v("手机登录")])] : _vm._e()], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7baa0a74", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7baa0a74!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/common/OtherButton.vue
// module id = 872
// module chunks = 0